import { colors } from "@mui/material";

const colorConfigs = {
  sidebar: {
    bg: "#F13748",
    color: "#eeeeee",
    hoverBg: "#FFFFFF",
    activeBg: "#1e253a"
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  textColor: "#FFFFFF",
  mainBg: colors.grey["100"],
  primaryColor:{
    red:{
      100:"#F5E2E4",
      200:"#F4CFD2",
      300:"#F3A9B0",
      400:"#F3838D",
      500:"#F25D6B",
      600:"#F13748",
    },
    blue:{
      100:"#E0E1E5"
    }
  }
};

export default colorConfigs;